import React from 'react'
import { NavigationHeader } from '@/components/NavigationHeader/NavigationHeader'
import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs'
import { useTabNavigate } from 'hooks/useTabNavigate'

import styles from './DividendsNavigation.module.scss'

interface InnerProps {
  tab: DividendsTab
}

export enum DividendsTab {
  CustomDividends = 'custom-dividends',
  CustomCorporate = 'custom-corporate',
  SystemCorporate = 'system-corporate',
}

export const DividendsNavigation: React.FC<InnerProps> = ({ tab }) => {
  const tabNavigate = useTabNavigate()

  return (
    <div className={styles.walletNavigation}>
      <NavigationHeader />
      <Tabs value={tab} onValueChange={tabNavigate} className='mt-2'>
        <TabsList>
          <TabsTrigger value={DividendsTab.CustomDividends}>Custom Dividends</TabsTrigger>
          <TabsTrigger value={DividendsTab.CustomCorporate}>Custom Corporate Events</TabsTrigger>
          <TabsTrigger value={DividendsTab.SystemCorporate}>System Corporate Actions</TabsTrigger>
        </TabsList>
      </Tabs>
    </div>
  )
}
